import * as React from 'react';

export const BaggageLg = (
	<svg width="35" height="55" viewBox="0 0 35 55" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M7.16122 9.25023H3.84353C1.77089 9.25023 0.0903874 11.0025 0.0908204 13.1646V46.7259C0.0908204 48.888 1.77133 50.6407 3.84397 50.6407H4.34788V53.4823C4.34788 54.0047 4.75322 54.4286 5.25518 54.4286H9.54669C10.0471 54.4286 10.454 54.0054 10.454 53.4823V50.6407H24.0465V53.4823C24.0465 54.0047 24.4522 54.4286 24.9538 54.4286H29.2457C29.7462 54.4286 30.1526 54.0054 30.1526 53.4823V50.6407H30.6559C32.7281 50.6407 34.409 48.8885 34.409 46.7259V13.1644C34.409 11.0027 32.7285 9.25 30.6559 9.25H27.3384V4.98264C27.3384 2.51119 25.4098 0.5 23.0402 0.5H11.4592C9.08914 0.5 7.16122 2.51119 7.16122 4.98264V9.25023ZM24.4735 9.25H10.0272V4.98264C10.0272 4.15882 10.67 3.48842 11.4599 3.48842H23.0408C23.8307 3.48842 24.4735 4.15882 24.4735 4.98264V9.25ZM4.74994 17.75C4.74994 17.1977 5.19765 16.75 5.74994 16.75H28.7499C29.3022 16.75 29.7499 17.1977 29.7499 17.75V19.5C29.7499 20.0523 29.3022 20.5 28.7499 20.5H5.74994C5.19765 20.5 4.74994 20.0523 4.74994 19.5V17.75ZM4.74994 25.25C4.74994 24.6977 5.19765 24.25 5.74994 24.25H28.7499C29.3022 24.25 29.7499 24.6977 29.7499 25.25V27C29.7499 27.5523 29.3022 28 28.7499 28H5.74994C5.19765 28 4.74994 27.5523 4.74994 27V25.25ZM5.74994 31.75C5.19765 31.75 4.74994 32.1977 4.74994 32.75V34.5C4.74994 35.0523 5.19765 35.5 5.74994 35.5H28.7499C29.3022 35.5 29.7499 35.0523 29.7499 34.5V32.75C29.7499 32.1977 29.3022 31.75 28.7499 31.75H5.74994ZM4.74994 40.25C4.74994 39.6977 5.19765 39.25 5.74994 39.25H28.7499C29.3022 39.25 29.7499 39.6977 29.7499 40.25V42C29.7499 42.5523 29.3022 43 28.7499 43H5.74994C5.19765 43 4.74994 42.5523 4.74994 42V40.25Z"
			fill="currentColor"
		/>
	</svg>
);

export const BaggageDelivery = (
	<svg width="86" height="85" viewBox="0 0 86 85" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g clip-path="url(#clip0_13176_80761)">
			<path
				d="M25.7062 34.5771H31.4689V31.1669C31.4689 30.6641 31.0597 30.255 30.557 30.255H26.6181C26.1153 30.255 25.7062 30.6643 25.7062 31.1669V34.5771ZM32.9096 37.4584H24.2655C23.4703 37.4584 22.8248 36.813 22.8248 36.0178V31.1669C22.8248 29.0752 24.5263 27.3737 26.6181 27.3737H30.557C32.6488 27.3737 34.3503 29.0752 34.3503 31.1669V36.0178C34.3501 36.813 33.7048 37.4584 32.9096 37.4584Z"
				fill="white"
			/>
			<path
				d="M53.079 36.0177H61.7231V24.4922H53.079V36.0177ZM63.1638 38.899H51.6383C50.8431 38.899 50.1976 38.2536 50.1976 37.4584V23.0515C50.1976 22.2563 50.8431 21.6108 51.6383 21.6108H63.1638C63.9605 21.6108 64.6045 22.2563 64.6045 23.0515V37.4584C64.6045 38.2536 63.9605 38.899 63.1638 38.899Z"
				fill="white"
			/>
			<path
				d="M66.0452 24.4922H48.757C47.9618 24.4922 47.3163 23.8467 47.3163 23.0515C47.3163 22.2563 47.9618 21.6108 48.757 21.6108H66.0452C66.8404 21.6108 67.4859 22.2563 67.4859 23.0515C67.4859 23.8467 66.8404 24.4922 66.0452 24.4922Z"
				fill="white"
			/>
			<path
				d="M66.0451 36.0171H48.5998C46.299 36.0171 44.4348 37.8813 44.4348 40.1821V54.746H50.1975V76.3561H66.2021C68.5029 76.3561 70.3671 74.4919 70.3671 72.1911V40.3391C70.3671 37.952 68.4322 36.0171 66.0451 36.0171Z"
				fill="#CE9865"
			/>
			<path d="M15.6213 76.3558H50.1976V54.7457H15.6213V76.3558Z" fill="#86573E" />
			<path
				d="M15.6213 61.9488V54.7454H22.8248C22.8248 58.7231 19.5991 61.9488 15.6213 61.9488Z"
				fill="#573728"
			/>
			<path
				d="M42.9941 54.7454H50.1976V61.9488C46.2198 61.9488 42.9941 58.7231 42.9941 54.7454Z"
				fill="#573728"
			/>
			<path
				d="M50.1976 69.1514V76.3548H42.9941C42.9941 72.3771 46.2198 69.1514 50.1976 69.1514Z"
				fill="#573728"
			/>
			<path
				d="M22.8248 76.3548H15.6213V69.1514C19.5991 69.1514 22.8248 72.3771 22.8248 76.3548Z"
				fill="#573728"
			/>
			<path d="M38.6721 54.7465H18.6093L21.384 34.5769H35.7907L38.6721 54.7465Z" fill="#5E5D58" />
			<path d="M31.4688 41.7811H25.7061L21.384 34.5776H35.7907L31.4688 41.7811Z" fill="#FFD06C" />
			<path d="M50.1975 47.5434H64.6043V41.7806H50.1975V47.5434Z" fill="#FFD06C" />
			<path
				d="M21.39 80.6783C21.39 78.2911 19.455 76.3562 17.0679 76.3562C14.6808 76.3562 12.7458 78.2911 12.7458 80.6783C12.7458 83.0654 14.6808 85.0003 17.0679 85.0003C19.455 85.0003 21.39 83.0656 21.39 80.6783Z"
				fill="#3E3E3F"
			/>
			<path
				d="M73.2542 80.6783C73.2542 78.2911 71.3195 76.3562 68.9322 76.3562C66.545 76.3562 64.6101 78.2911 64.6101 80.6783C64.6101 83.0654 66.5449 85.0003 68.9322 85.0003C71.3195 85.0003 73.2542 83.0656 73.2542 80.6783Z"
				fill="#3E3E3F"
			/>
			<path
				d="M77.5762 77.7969H8.42371V30.2545C8.42371 19.9277 16.8258 11.5256 27.1526 11.5256H58.8475C69.1743 11.5256 77.5764 19.9277 77.5764 30.2545V77.7969H77.5762ZM11.3051 74.9155H74.695V30.2545C74.695 21.5168 67.5852 14.407 58.8475 14.407H27.1524C18.4147 14.407 11.3049 21.5168 11.3049 30.2545V74.9155H11.3051Z"
				fill="#E2E4E4"
			/>
			<path
				d="M54.5254 14.4069H31.4745V8.64999C31.4745 7.05807 32.7696 5.76282 34.3617 5.76282H51.6382C53.2302 5.76282 54.5254 7.05791 54.5254 8.64999V14.4069ZM34.3573 11.5256H51.6441V8.64999L34.3617 8.64418L34.3573 11.5256Z"
				fill="#E2E4E4"
			/>
			<path
				d="M48.7627 8.6441H37.2372V5.76273C37.2372 2.58453 39.8217 0 42.9999 0C46.1781 0 48.7627 2.58453 48.7627 5.76273V8.6441ZM40.1186 5.76273H45.8813C45.8813 4.17363 44.589 2.88137 42.9999 2.88137C41.4108 2.88137 40.1186 4.17363 40.1186 5.76273Z"
				fill="#E2E4E4"
			/>
			<path
				d="M81.8983 77.7959H4.10169C3.30648 77.7959 2.66101 77.1505 2.66101 76.3552C2.66101 75.56 3.30648 74.9146 4.10169 74.9146H81.8983C82.6935 74.9146 83.339 75.56 83.339 76.3552C83.339 77.1505 82.6935 77.7959 81.8983 77.7959Z"
				fill="#FBBF2D"
			/>
		</g>
		<defs>
			<clipPath id="clip0_13176_80761">
				<rect width="85" height="85" fill="white" transform="translate(0.5)" />
			</clipPath>
		</defs>
	</svg>
);
